import { LangText } from '@/components'
import { handleClick } from '@/components/OutLink'
import { JAPAN_MALL_URL } from '@/constants'
import { PlatformEnum } from '@/service/api/types'
import { preFixImgUrl } from '@/utils'

const openJapanMall = (path = '') => {
  return handleClick({
    platform: PlatformEnum.JAPANMALL,
    linUrl: `${JAPAN_MALL_URL}${path}`,
  })
}

const HeroBanner = () => (
  <section
    className="h-[320px] w-full bg-cover bg-center bg-no-repeat"
    style={{
      backgroundImage: `url(${preFixImgUrl('a4395f0be558f7508be95557a490ea86.png')})`,
    }}
  >
    <div className="mx-auto flex h-full w-[1200px] flex-col justify-center text-white">
      <LangText
        lngKey="hanedaShop.hero.title"
        className="font-smiley-sans text-[40px] font-bold leading-[48px]"
      />
      <LangText
        lngKey="hanedaShop.hero.description"
        className="mt-[16px] text-[20px] leading-[28px] text-white/80"
      />

      <div className="mt-[16px] flex items-center gap-[12px]">
        <button
          type="button"
          className="flex h-[40px] cursor-pointer items-center justify-center rounded-full border border-[#328BF8] bg-white px-[24px] text-[16px] text-primary transition-opacity hover:opacity-90"
          onClick={() => openJapanMall()}
        >
          <LangText lngKey="hanedaShop.hero.shopNow" />
        </button>

        <button
          type="button"
          className="flex h-[40px] cursor-pointer items-center justify-center rounded-full border border-white bg-transparent px-[24px] text-[16px] text-white transition-opacity hover:opacity-80"
          onClick={() => openJapanMall('/special?id=138&storeId=17')}
        >
          <LangText lngKey="hanedaShop.hero.viewPickupLocations" />
        </button>
      </div>
    </div>
  </section>
)

export default HeroBanner
